// extracted by mini-css-extract-plugin
export default {"contextMenu":"ContextMenu_contextMenu__XMXcq","contextMenuItem":"ContextMenu_contextMenuItem__yAOiV","line":"ContextMenu_line__y6LbL","nameItem":"ContextMenu_nameItem__YcOye"};